"use strict";

exports.__esModule = true;
var _PlantInfo = require("./PlantInfo");
Object.keys(_PlantInfo).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PlantInfo[key]) return;
  exports[key] = _PlantInfo[key];
});
var _PlantListContext = require("./PlantListContext");
Object.keys(_PlantListContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _PlantListContext[key]) return;
  exports[key] = _PlantListContext[key];
});